import { render } from "./filter.vue?vue&type=template&id=4580e5b8&ts=true"
import script from "./filter.vue?vue&type=script&lang=ts"
export * from "./filter.vue?vue&type=script&lang=ts"

import "./filter.vue?vue&type=style&index=0&id=4580e5b8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__